import React from 'react';
import styles from './sectionHeader.module.scss';
import classnames from 'classnames';

interface ContactTabOwnProps {
  title: string;
  isEditable?: boolean;
  className?: string;
  titleClassName?: string;
  onClick?: () => void;
}

const SectionHeader = ({
  title,
  isEditable = false,
  onClick,
  className,
  titleClassName,
}: ContactTabOwnProps) => {
  return (
    <div className={classnames(styles.header, className)}>
      <div
        className={classnames(
          'text-primary-dark',
          titleClassName ?? styles.title
        )}
      >
        <span data-testid={`header_${title.replaceAll(' ', '')}`}>{title}</span>
      </div>
      {isEditable && onClick && (
        <label
          data-cy={`edit-${title}-button`}
          data-testid={`edit_${title.replaceAll(' ', '')}`}
          className={styles.edit}
          onClick={() => onClick()}
        >
          Edit
        </label>
      )}
    </div>
  );
};

export default SectionHeader;
